<template>
  <CForm ref="uploadimage">
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <CRow >
        <CCol sm="6">Images here</CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <CInputFile
            v-if="productCategory.images === null"
            ref="fileupload"
            label
            accept="image/*"
            invalid-feedback="Name should be filled"
            required
            @change="onFileChange"
          />

          <CInput
            :type="'hidden'"
            required
            v-model="$v.uploadImageForm.images.$model"
            :is-valid="!$v.uploadImageForm.images.$invalid"
          ></CInput>

          <CButton
            @click="submitForm"
            :disabled="$v.uploadImageForm.$invalid"
            color="success"
          >
            <i class="fa fa-save"></i>
            Save Image </CButton
          >&nbsp;
          <CButton @click="removeImage" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>
        </CCol>
        <CCol sm="2">
          <div>Preview :<br /></div>
          <CCard v-if="productCategory.images === null && uploadImageForm.images !== null"  >
            <CImg :src="uploadImageForm.images" :thumbnail="true" />
          </CCard>
          <CCard v-else-if="productCategory.images !== null">
            <div @click="previewForm" style="cursor: pointer">
              <CImg :src="'https://storage.googleapis.com/isikulkas/' + productCategory.images +'?r=' +unixTime" :thumbnail="true"/>
            </div>
          </CCard>
          <CCard v-else>
            <CCardBody>
              <CRow>
                <div>
                  <CCol sm="12">No image</CCol>
                </div>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CModal
        title="Image Preview"
        color="success"
        size="lg"
        :closeOnBackdrop="false"
        :show.sync="preview"
      >
          <CImg :src="'https://storage.googleapis.com/isikulkas/' + productCategory.images +'?r=' +unixTime" :thumbnail="true"/>
      </CModal>
    </div>
  </CForm>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  name: "ProductCategoryImages",
  components: { Loading },
  data() {
    return {
      title: "Upload Image",
      items: [],
      uploadImageForm: tableInterfaces.product_category,
      isLoading: false,
      image: null,
      activeTab: 0,
      preview: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
    };
  },
  props: {
    productCategory: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    uploadImageForm: {
      images: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    submitForm: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.uploadImageForm.id = this.productCategory.id;
        this.uploadImageForm.name = this.productCategory.name;

        this.axios
          .put("console/master/product_category/update-image", this.uploadImageForm)
          .then((response) => {
            this.productCategory.images = response.data.images;
            this.$emit("update:productCategory", this.productCategory);
            this.resetUpload();
            this.showInfoNotification({
              title: "Ubah productCategory Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired",
              });
            } else {
              this.showErrorNotification({
                title: "productCategory Images",
                message: error.response.data.message,
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetUpload: function () {
      this.$refs.uploadimage.reset();
      this.$refs.fileupload.value = null;
      this.uploadImageForm.images = null;
    },
    onFileChange: function(e) {
      this.createImage(e[0]);
    },
    createImage: function(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm.images = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      if (confirm("Apakah anda ingin menghapus Data ini ?")) {
        this.isLoading = true;
        var remove = { images: this.productCategory.images, id: this.productCategory.id };

        this.axios
          .put("console/master/product_category/remove-image", remove)
          .then((response) => {
            this.resetUpload();
            this.productCategory.images = null;
            this.showInfoNotification({
              title: "Remove productCategory Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired",
              });
            } else {
              this.showErrorNotification({
                title: "productCategory Images",
                message: error.response.data.message,
              });
            }
          })
          .finally(() => {
            //this.isLoading = false;
            this.$router.go(0);
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>